import { projectsApi } from "@facade/services/projectsApi";
import { queryOptions } from "@tanstack/react-query";

export const projectQueryKeys = {
  all: ["projects"] as const,
  details: () => [...projectQueryKeys.all, "detail"] as const,
  detail: (projectId: string) =>
    [...projectQueryKeys.details(), projectId] as const,
};

export const projectsQueries = {
  list: () =>
    queryOptions({
      queryKey: projectQueryKeys.all,
      queryFn: () => projectsApi.get({ includeNotificationCounts: true }),
    }),
  detail: (projectId: string) =>
    queryOptions({
      queryKey: projectQueryKeys.detail(projectId),
      queryFn: () => projectsApi.getById(projectId),
    }),
};
